module.exports = __webpack_public_path__ + "static/media/error-bg.48d61f01.jpg";